/**
 * 全站路由路径统一尾斜杠（首页 `/` 除外）
 */

/** 规范为带尾斜杠的路径，供路由定义与 router-link 使用 */
export function withTrailingSlash(path) {
	if (!path || path === '/') return '/';
	const clean = path.split('?')[0].split('#')[0];
	return clean.endsWith('/') ? clean : `${clean}/`;
}

/** 是否应对 URL 追加尾斜杠（排除静态资源、API） */
export function shouldAddTrailingSlash(pathname) {
	if (!pathname || pathname === '/') return false;
	if (pathname.endsWith('/')) return false;
	// 带扩展名的静态文件
	if (/\.[a-zA-Z0-9]{2,8}$/.test(pathname)) return false;
	return true;
}
